import { useRecoilValue } from 'recoil';

import { Icon } from '@/components/icon';
import { Text } from '@/components/text';
import { ID_IMO } from '@/lib/constants';
import { getVehicleName } from '@/lib/models/vehicle/utils/get-vehicle-name';
import { getVehicleTeu } from '@/lib/models/vehicle/utils/get-vehicle-teu';
import { vehiclesState } from '@/state/vehicles';
import { RouteLinkVehicleApiV4Interface } from '@/types/api-types';
import { tv } from '@/utils/styles';

export interface LineVehiclesProps {
  vehicles?: RouteLinkVehicleApiV4Interface[];
}

const LineVehicles = ({ vehicles }: LineVehiclesProps) => {
  const vehicleDictionary = useRecoilValue(vehiclesState);

  const mergedVehicles = vehicles
    ? vehicles.map((vehicle) => {
        const vessel = vehicleDictionary[vehicle.vehicleId];
        return {
          ...vehicle,
          vessel,
        };
      })
    : [];

  const { base, vehicleRow, vehicleName, vehicleText, vehicleIcon } = styles();

  return (
    <div className={base()}>
      {mergedVehicles.map((vehicle) => {
        const vehicleImo = vehicle.vessel.identifiers.find((id) => id.type === ID_IMO);
        const vehicleTeu = getVehicleTeu(vehicle.vessel);

        return (
          <div key={vehicle.vehicleId} className={vehicleRow()}>
            <Icon name="ship" color="text.primary" className={vehicleIcon()} />
            <div>
              <Text variant="secondary" className={vehicleName()}>
                {getVehicleName(vehicle.vessel)}
              </Text>
              <Text variant="secondary" className={vehicleText()}>
                IMO {vehicleImo?.value} ({vehicleTeu})
              </Text>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'h-full overflow-auto',
    vehicleIcon: 'ml-1 mr-4',
    vehicleRow: 'mb-4 flex last:mb-0',
    vehicleName: 'm-0',
    vehicleText: 'm-0 grid text-sm text-text-secondary',
  },
});

export { LineVehicles };
